/**
 * Esta janela é uma janela própria da mesa (docs/spec/popout-windows.md)? A URL dela diz qual:
 * `/?popout=window&win=<windowId>&room=<roomId>&main=<mainId>`.
 * - A de um espaço, de antes de 2026-10-29 (`?popout=panel&node=<nodeId>`), ainda vale: a janela
 *   tinha o id do espaço, e o layout guardado passa a marca dele para esse id.
 * - A de uma aba só (`?popout=<classId>&sheet=<sheetId>`) vira uma janela que a principal não
 *   conhece, e ela manda fechar.
 * Lido uma vez, sem dependências, para quem só precisa saber o modo (avisos, store).
 */
export type PopoutSpec = {
  roomId: string;
  /** a janela principal que a abriu */
  mainId: string;
  /** a janela no layout da principal: a marca `out` da raiz do pedaço dela */
  windowId: string;
};

export function parsePopout(search: string): PopoutSpec | null {
  const q = new URLSearchParams(search);
  const kind = q.get('popout');
  const roomId = q.get('room');
  const mainId = q.get('main');
  if (!kind || !roomId || !mainId) return null;
  const windowId = q.get(kind === 'window' ? 'win' : kind === 'panel' ? 'node' : 'sheet');
  return windowId ? { roomId, mainId, windowId } : null;
}

export const POPOUT: PopoutSpec | null = typeof window === 'undefined' ? null : parsePopout(window.location.search);
